import { ReduceStore } from "flux/utils";
import AppDispatcher from "../AppDispatcher";
import Constants from "../Constants";
import Immutable, { Map, List, Record } from "immutable";

export const ProjectEntry = Record({ name: null, id: null, pages: new List() });
export const PageEntry = Record({ name: null, id: null });

class ContentStore extends ReduceStore {
  getInitialState() {
    return new Map({ entries: new Map(), assets: new Map(), index: null });
  }

  reduce(state, action) {
    switch (action.actionType) {
      case Constants.Content.CONTENT_RECEIVED:
        return this.loadContent(state, action);
      case Constants.Content.INDEX_RECEIVED:
        return state.set("index", Immutable.fromJS(action.index.projects));
      default:
        return state;
    }
  }

  getProjects() {
    return this.getState()
      .get("entries")
      .filter((v) => {
        return v.getIn(["sys", "contentType", "sys", "id"]) == "district";
      })
      .toList();
  }

  getPages(extraFilter = (x) => true) {
    return this.getState()
      .get("entries")
      .filter((v) => {
        return (
          v.getIn(["sys", "contentType", "sys", "id"]) == "page" &&
          extraFilter(v)
        );
      });
  }

  getTree() {
    const index = this.getState().get("index");
    return (
      index &&
      index
        .map((project) => {
          const id = project.get("id");
          return ProjectEntry({
            name: project.get("name"),
            id,
            pages: project
              .get("pages")
              .map((page) =>
                PageEntry({
                  id: page.get("id"),
                  name: page.get("name"),
                })
              )
              .toList()
              .sortBy((page) => page.name),
          });
        })
        .sortBy((project) => project.name)
    );
  }

  getDefaultPageId() {
    const index = this.getState().get("index");
    if (!index) {
      return null;
    }
    const allPages = index.flatMap((project) => project.get("pages", List()));
    const defaultPage = allPages.find(
      (page) => page.get("name") == "Home Page",
      null,
      allPages.first()
    );
    return defaultPage ? defaultPage.get("id") : null;
  }

  findProjectForPageInIndex(pageId) {
    const index = this.getState().get("index");
    if (!index) {
      return null;
    }
    return index.find(
      (project) =>
        project.get("pages").some((page) => page.get("id") == pageId),
      null,
      Map()
    );
  }

  loadContent(state, { content, projects }) {
    // TODO: should probably only replace if revision number is >= current revision number
    return state.withMutations((mutableState) => {
      mutableState
        .update("entries", (oldPages) =>
          oldPages.withMutations((mutablePages) => {
            content.items.forEach((entry) => {
              mutablePages.set(entry.sys.id, Immutable.fromJS(entry));
            });
          })
        )
        .update("assets", (oldAssets) =>
          oldAssets.withMutations((mutableAssets) => {
            if (content.includes && content.includes.Asset) {
              content.includes.Asset.forEach((entry) => {
                mutableAssets.set(entry.sys.id, Immutable.fromJS(entry));
              });
            }
          })
        )
        .update("entries", (oldEntries) =>
          oldEntries.withMutations((mutableEntries) => {
            if (content.includes && content.includes.Entry) {
              content.includes.Entry.forEach((entry) => {
                mutableEntries.set(entry.sys.id, Immutable.fromJS(entry));
              });
            }
          })
        )
        .update("loaded", (oldValue) => oldValue || projects);
    });
  }

  hasLoadedProjects() {
    return this.getState().get("loaded");
  }
}

const instance = new ContentStore(AppDispatcher);
export default instance;
